export const nav = {
  dashboard: 'Vezérlőpult',
  customers: 'Ügyfelek',
  customerGroups: 'Ügyfélcsoportok',
  leads: 'Lead-ek',
  documentStorage: 'Könyvtár',
  documentLibrary: 'Könyvtár',
  suppliers: 'Beszállítók',
  notes: 'Cetlik',
  richNotes: 'Jegyzetfüzet',
  appointments: 'Időpontfoglalás',
  customerPortal: 'Ügyfélportál',
  portalPreview: 'Portál előnézet',
  missingItems: 'Hiánylista',
  customerProjects: 'Ügyfél Ticketek',
  customerRelationshipLogs: 'Ügyfélkapcsolati napló',
  products: 'Termékek',
  categories: 'Kategóriák',
  warehouse: 'Raktárak',
  inventory: 'Készlet',
  warranty: 'Garancia',
  offers: 'Árajánlatok',
  ai_quotations: 'AI Árajánlatok',
  deals: 'Ügyletek',
  contracts: 'Dokumentumok',
  worksheets: 'Munkalapok',
  reports: 'Jelentések',
  settings: 'Beállítások',
  profile: 'Profil',
  system_admin: 'Rendszergazda',
  storageOptimization: 'Storage Optimalizálás',
  templates: 'Sablonok',
  documentVariables: 'Változók',
  formBuilder: 'Űrlapok és Listák',
  formBuilderEditor: 'Form Builder',
  flowBuilder: 'Flow Builder',
  myForms: 'Saját Űrlapok',
  workPagesTemplates: 'Kitöltendő munkalap',
  filledWorkpage: 'Kitöltött munkalap',
  billing: 'Számlázás',
  billingSubtitle: 'Számlák, díjbekérők és jóváírások kezelése',
  subscriptions: 'Előfizetések',
  subscriptionsSubtitle: 'Előfizetések és fizetések kezelése',
  tasks: 'Feladatok',
  tasksSubtitle: 'Feladatok és teendők kezelése',
  projects: 'Projektek',
  projectsSubtitle: 'Projektek kezelése és nyomon követése',
  projectBoard: 'Projekt Board',
  projectReports: 'Projekt Riportok',
  projectReportsSubtitle: 'Projektek és feladatok elemzése',
  flowDebug: 'Flow Naplók',
  flowDebugSubtitle: 'Flow futási naplók és hibakeresés',
  pipeline: 'Pipeline',
  quotations: 'Árajánlatok',
  campaigns: 'Kampányok',
  duplicateScanner: 'Duplikáció kereső',
  worksheetTemplates: 'Munkalap sablonok',
  worksheetSettings: 'Munkalap beállítások',
  orders: 'Megrendelések',
  delivery_notes: 'Szállítólevelek',
  sales: 'Értékesítés',
  organization: 'Szervezet',
  selectOrganization: 'Válassz szervezetet',
  groups: {
    crm: 'CRM & Kapcsolatok',
    customerPortal: 'Ügyfélportál',
    products: 'Termékek & Készlet',
    sales: 'Értékesítés & Rendelések',
    worksheets: 'Munkalapok',
    documents: 'Dokumentumok',
    contracts: 'Szerződések',
    forms: 'Űrlapok',
    processes: 'Folyamatok',
    projects: 'Projektek & Feladatok',
    finance: 'Pénzügyek'
  },
  expandSidebar: 'Oldalsáv kibontása',
  collapseSidebar: 'Oldalsáv összecsukása',
  favorites: 'Kedvencek',
  pin: 'Kedvencekhez',
  unpin: 'Eltávolítás',
  commandPalette: {
    placeholder: 'Navigálj bárhová...',
    noResults: 'Nincs találat',
    tryDifferent: 'Próbálj másik keresőkifejezést',
    navigate: 'Navigálás',
    select: 'Kiválasztás',
    close: 'Bezárás'
  }
}